import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import './FAQSection.css';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What types of video editing services do you offer?',
      answer: 'We offer wedding films, corporate videos, social media content, documentaries, AD films, and event coverage.'
    },
    {
      question: 'How long does it take to complete a project?',
      answer: 'Wedding films: 2-3 days, Corporate videos: ~1 week, Social media content: 1 day.'
    },
    {
      question: 'Do you offer revisions?',
      answer: 'Yes! Basic: 2 revisions, Professional: 4 revisions, Premium: Unlimited revisions.'
    },
    {
      question: 'What file formats do you accept?',
      answer: 'We accept all major formats: MP4, MOV, AVI, RAW. Deliverables in MP4 (H.264), 4K, HDR available.'
    },
    {
      question: 'Can you work with international clients?',
      answer: 'Yes! We work globally with seamless file transfer and flexible timezone communication.'
    },
    {
      question: 'What is your pricing structure?',
      answer: 'Basic: ₹15,000, Professional: ₹35,000, Premium: ₹75,000. Contact us for custom quotes.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Split FAQs into two columns
  const leftFaqs = faqs.slice(0, 3);
  const rightFaqs = faqs.slice(3, 6);

  return (
    <section className="faq-section section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Quick answers to common questions
          </p>
        </div>

        <div className="faq-grid">
          <div className="faq-column">
            {leftFaqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? 'active' : ''}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="faq-question-text">{faq.question}</span>
                  <span className="faq-icon">
                    {openIndex === index ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="faq-column">
            {rightFaqs.map((faq, index) => {
              const actualIndex = index + 3;
              return (
                <div
                  key={actualIndex}
                  className={`faq-item ${openIndex === actualIndex ? 'active' : ''}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(actualIndex)}
                  >
                    <span className="faq-question-text">{faq.question}</span>
                    <span className="faq-icon">
                      {openIndex === actualIndex ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div className={`faq-answer ${openIndex === actualIndex ? 'open' : ''}`}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
